{
  "modelName": "Model Portfolio",
  "modelPortfolioTable": {
    "name": "Model Name",
    "newModelName": "New Model Name",
    "newModelNameBottomLabel": "You can change this later in model details.",
    "theme": "Group",
    "description": "Model Description",
    "tag": "Tag",
    "type": "Type",
    "#OfAccounts": "# of Accounts",
    "#OfPortfolios": "# of Portfolios",
    "assetClass": "Asset Class",
    "status": "Status",
    "valueAssigned": "Value Assigned",
    "filterModal": {
      "none": "None",
      "modalTitle": "Filter Model Portfolios",
      "groupTitle": "Group"
    },
    "createModel": "Create new Model",
    "createTheme": "Create new Group",
    "modelFamily": "Model Family",
    "totalCount": "Count",
    "actions": {
      "clone": "Clone Model",
      "edit": "Edit Model",
      "activate": "Activate Model",
      "draft": "Move to Draft",
      "archive": "Move to Archive"
    },
    "archive": {
      "disabledTooltip": "Cannot archive: currently assigned to {{count}} sub-account(s) or goal(s).",
      "disabledTooltipUnknown": "Cannot archive: usage could not be loaded. Try refreshing."
    },
    "error": {
      "transitionModelPortfolio": "Unable to transition model portfolio"
    }
  },
  "createModelPortfolio": {
    "name": "Model Name",
    "description": "Model Description",
    "type": "Model Type",
    "FROM_SCRATCH": "From Scratch",
    "FROM_TEMPLATE": "From Template",
    "label": "Create model portfolio",
    "driftCalculationMethodLabel": "Drift Calculation Method",
    "driftTolerancePercentLabel": "Drift Tolerance",
    "driftInherited": "{{method}} (Inherited)",
    "driftToleranceRangeError": "Enter a whole number between 5 and 20, or leave blank to inherit.",
    "driftSettingsTooltip": "How far a portfolio may drift from its target before rebalancing is flagged. Leave blank to inherit the organization default. Absolute bands are capped at 0%. A 5% target with a 10% band therefore triggers between 0% and 15%.",
    "driftToleranceHint": "Enter a whole number between 5-20%, or leave blank to inherit",
    "driftInheritedUnknown": "Inherited"
  },
  "strategy": {
    "label": "Model Strategy",
    "STANDARD": "Standard",
    "ASSET_CLASS": "Asset Grouped"
  },
  "assetClassIPSDisclaimer": "These values are for informational purposes only",
  "assetClassLevel": "Asset Class Level",
  "assetClassLevelPlaceholder": "Select Asset Class Level",
  "PRIMARY": "Primary Asset Class",
  "SECONDARY": "Secondary Asset Class",
  "TERTIARY": "Tertiary Asset Class",
  "autoTarget": "Auto Target",
  "unassigned": "Unassigned",
  "withinGroupPercent": "Within-group %",
  "riskProfile": {
    "CONSERVATIVE": "Conservative",
    "MODERATELY_CONSERVATIVE": "Moderately Conservative",
    "MODERATE": "Moderate",
    "GROWTH": "Growth",
    "AGGRESSIVE": "Aggressive",
    "VERY_AGGRESSIVE": "Very Aggressive"
  },
  "addSecurity": "+ Add Security",
  "addSecuritiesDialog": {
    "title": "Add securities",
    "search": "Search by ticker or name",
    "inModel": "In model",
    "selected_one": "{{count}} security selected",
    "selected_other": "{{count}} securities selected",
    "clearSelection": "Clear selection",
    "noResults": "No securities match this search or filter.",
    "loadError": "The product shelf could not be loaded. Try again."
  },
  "addCash": "+ Add Cash",
  "cashEquivalentSecurity": "Cash Equivalent Security",
  "createNewTemplate": "Create New Template",
  "selectTemplate": "Select template",
  "templateName": "Template Name",
  "templateDescription": "Template Description",
  "createAndUseTemplate": "Create and Use Template",
  "addAssetClassBranch": "+ Add",
  "min": "Min",
  "max": "Max",
  "actualPercentage": "Actual %",
  "assetClasses": "Asset Classes",
  "assetClass": "Asset Class",
  "assetAllocation": "Asset Allocation",
  "portfolioDetails": {
    "details": {
      "fundamentalDetailsLink": "Fundamental Details Link",
      "zeroPercentCash": "0% Cash",
      "riskProfile": "Risk Profile"
    }
  },
  "remove": "Remove",
  "cashEquivalent": "Cash Equivalent",
  "portfolio": {
    "tabs": {
      "assetAllocation": "Asset Allocation",
      "details": "Details",
      "invPolicyStatement": "Investment Policy Statement",
      "auditLog": "Audit Log"
    },
    "edit": {
      "save": "Save",
      "cancel": "Cancel"
    },
    "details": {
      "genDetails": "General Details",
      "name": "Name",
      "suggestable": "Suggestible",
      "modelFamily": "Model Family",
      "url": "URL",
      "riskReturn": "Risk and Return",
      "lowThresholdScore": "Lowest Threshold Score",
      "minScore": "Minimum Score",
      "maxScore": "Maximum Score",
      "riskReturnLevel": "Risk/Return Level",
      "forecastRateReturn": "Forecasted Rate of Return",
      "forecastStandardDeviation": "Forecasted Standard Deviation",
      "riskProfileName": "Risk Profile Name",
      "riskProfileDescription": "Risk Profile Description",
      "suggest": {
        "yes": "Yes",
        "no": "No"
      }
    },
    "policyAndAssets": {
      "description": "Description",
      "investmentObjective": "Investment Objective",
      "liquidity": "Liquidity",
      "disclaimer": "Disclaimer",
      "assetAllocation": "Asset Allocation"
    },
    "noAccess": "You do not have read access. Please contact your administrator.",
    "success": "Model portfolio updated successfully",
    "createActiveSuccess": "Active Model Portfolio created successfully.",
    "draftSaveSuccess": "Model portfolio draft saved successfully.",
    "saveError": "Failed to save model portfolio",
    "updateError": "Failed to update model portfolio",
    "createError": "Failed to create model portfolio",
    "missingAssetClassLevel": "Please select an Asset Class Level before saving an Asset Grouped portfolio.",
    "error": "Unable to update model portfolio",
    "exceedsTotalAllocation": "Exceeds total allocation",
    "totalAllocationError": "The current total of {{totalPercentage}} exceeds the maximum allowed allocation. Please adjust the target allocation to total {{maxPercentage}}",
    "ok": "OK",
    "noSecuritiesUrl": "No securities found",
    "securitiesOrderedByTaxRank": "Securities are ordered by Tax Rank, to change you can drag and drop or manually update it.",
    "zeroPercentError": "Securities with 0% allocation are not allowed.",
    "noFinancialProductError": "Securities with no financial product are not allowed.",
    "noPercentageError": "Securities with no percentage are not allowed.",
    "invalidPrimaryAssetClass": "Securities with no primary asset class are not allowed.",
    "noSecurityError": "No securities found",
    "incompleteAllocationError": "Asset class allocations must total exactly 100% before you can continue.",
    "unassignedSecuritiesError": "All securities must belong to an asset class group.",
    "groupAllocationError": "Each asset class group must have at least one security and its allocations must total exactly 100%.",
    "duplicateTaxRankError": "Duplicate tax ranks are not allowed. Please ensure each security has a unique tax rank.",
    "taxRankGapsError": "Tax ranks must start at 1 and have no gaps. Please ensure ranks form a consecutive sequence starting from 1.",
    "strategyChangedSecuritiesCleared": "Switching strategy has cleared the securities list."
  },
  "templateDoesntMatch": {
    "title": "Template doesn't match",
    "body": "The model you have built is not aligned to the Template used. Do you wish to continue?"
  },
  "exportHeaders": {
    "securityId": "Security ID",
    "isCashEquivalent": "Is Cash Equivalent",
    "financialProductId": "Financial Product - ID",
    "primaryAssetClassId": "Primary Asset Class - ID",
    "primaryAssetClassName": "Primary Asset Class - Name",
    "secondaryAssetClassId": "Secondary Asset Class - ID",
    "secondaryAssetClassName": "Secondary Asset Class - Name",
    "financialProductIsCash": "Financial Product - Is Cash",
    "financialProductTaxRank": "Financial Product - Tax Rank",
    "financialProductTicker": "Financial Product - Ticker",
    "financialProductName": "Financial Product - Name"
  },
  "exportConfig": {
    "progressTitle": "Exporting Model Portfolio Securities"
  },
  "success": {
    "cloneModelPortfolio": "Model portfolio cloned successfully"
  },
  "copyOfPrefix": "Copy of {{name}}",
  "clearFilter": "Clear Filter",
  "importCsv": {
    "title": "Import CSV?",
    "description": "If you've already created a model in Excel, you can choose to import it by either clicking Upload icon right above the security table, or drag and drop the CSV file in the import dialog.",
    "modalTitle": "Import CSV file",
    "modalDescription": "Import a CSV file to quickly add securities to your portfolio. Please ensure your CSV includes the following columns: Security Identifier (Ticker), Target Weight %, Tax Rank (optional).",
    "import": "Import file",
    "uploadTooltip": "Upload CSV file",
    "downloadTemplate": "Download Template",
    "successMessage": "Securities imported successfully",
    "errorMessage": "Failed to import securities",
    "reviewTitle": "Review Securities",
    "reviewDescription": "The following securities are not available. Replace with Cash or another security to continue.",
    "progress": {
      "parsing": "Parsing CSV file...",
      "validatingData": "Validating CSV data...",
      "extractingSecurities": "Extracting securities...",
      "fetchingSecurities": "Fetching securities...",
      "processingSecuritiesData": "Processing securities data...",
      "validatingRows": "Validating CSV rows...",
      "fetchingReplacementSecurities": "Fetching all available securities for replacement...",
      "finalizing": "Finalizing import...",
      "complete": "Import complete!"
    },
    "errors": {
      "totalAllocation": "Total allocation must equal {{total}}% (currently {{current}}%)",
      "selectReplacements": "Please select replacements for: {{tickers}}",
      "rowMissingIdentifier": "Row {{rowNumber}}: Missing security identifier",
      "invalidTargetWeight": "Row {{rowNumber}} (Ticker: {{ticker}}): Invalid target weight \"{{targetWeight}}\" (must be between {{min}}-{{max}})",
      "invalidTaxRank": "Row {{rowNumber}} (Ticker: {{ticker}}): Invalid tax rank \"{{taxRank}}\" (must be >= {{min}})",
      "duplicateTaxRanks": "Duplicate tax ranks found in CSV. Each provided tax rank must be unique.",
      "failedToImportPrefix": "Failed to import CSV:",
      "moreErrorsOne": "... and {{count}} more error",
      "moreErrorsMany": "... and {{count}} more errors",
      "emptyFile": "CSV file is empty",
      "fileTooLarge": "File size ({{fileSize}}MB) exceeds maximum allowed size of {{maxSize}}MB. Please use a smaller file.",
      "failedToParse": "Failed to parse CSV: {{reason}}",
      "maxRowsExceeded": "CSV exceeds maximum allowed rows ({{maxRows}}). Found at least {{rowsProcessed}} rows.",
      "noData": "No data found in CSV file"
    }
  },
  "securityTableColumns": {
    "security": "Security",
    "assetClass": "Asset Class",
    "taxRank": "Tax Rank",
    "targetPercentage": "Target %",
    "portfolioPercentage": "Portfolio %"
  },
  "securityTablePercentageInfoTitle": "Target % and Portfolio %",
  "securityTablePercentageInfo": "**Target %** — Fund allocation within its asset class group. Each group must total 100%.\n\n**Portfolio %** — Fund allocation across the entire model portfolio. All funds total 100%.",
  "securityTablePortfolioPercentageInfo": "Total weight (within-class % × group %)",
  "securityTablePortfolioPercentageInfoAria": "Portfolio percent column help",
  "drift": {
    "sectionLabel": "Drift Settings",
    "confirmTitle": "Recalculate holders of this model portfolio?",
    "confirmBody": "This will recalculate all holders of this model portfolio. Drift settings stay locked until it finishes.",
    "confirmApply": "Apply",
    "recalculationComplete": "Recalculation complete for {{name}}.",
    "reviewRebalanceReport": "Review the rebalance report for portfolios now beyond their target allocations.",
    "activeModelTradesNotice": "This update won't affect any trades currently being processed — if trades are already underway, the model may or may not be back in balance once they settle."
  }
}
